import { LocationState } from "@/screens/app/screens/post/post.type";

export const generateNewPostUrl = (
  params?: LocationState & {
    postProjectId?: number;
  },
): {
  pathname: string;
  state?: LocationState;
} => {
  const { postProjectId, ...locationState } = params || {};

  if (postProjectId !== undefined) {
    return {
      pathname: `/post/${postProjectId}`,
    };
  }

  return {
    pathname:
      locationState?.pageConfigId !== undefined ||
      locationState?.groupId !== undefined
        ? "/post/new/general/schedule"
        : "/post/new/general/pages",
    state: locationState || undefined,
  };
};
